import { render } from "./BrandLogoMark.vue?vue&type=template&id=181d98aa&scoped=true"
import script from "./BrandLogoMark.vue?vue&type=script&lang=js"
export * from "./BrandLogoMark.vue?vue&type=script&lang=js"

import "./BrandLogoMark.vue?vue&type=style&index=0&id=181d98aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181d98aa"]])

export default __exports__